const URL_PARAMS = {
  partner: 'worldfirst',
};

const TARGET_PATH = '/user/register';

const STORAGE_KEY = 'visited_routes';

/**
 * 判断是否首次访问特定路由（刷新不计算为新访问）
 * @param {string} pathname 当前路径
 * @param {string} search 查询参数
 * @param {Object} options 配置选项
 * @param {string} options.targetPath 目标路径
 * @param {Object} options.targetParams 目标参数键值对
 */
export const isFirstVisit = (
  pathname: string,
  search: string,
  options = {
    targetPath: TARGET_PATH,
    targetParams: { partner: URL_PARAMS },
    storageKey: STORAGE_KEY,
  },
): boolean => {
  const { targetPath, targetParams, storageKey } = options;

  // 检查是否匹配目标路径
  if (pathname !== targetPath) {
    return false;
  }

  // 解析当前 URL 参数
  const searchParams = new URLSearchParams(search);

  // 检查是否包含所有目标参数
  const matchesAllParams = Object.entries(targetParams).every(
    ([key, value]) => searchParams.get(key) === value.partner,
  );

  if (!matchesAllParams) {
    return false;
  }

  // 构建存储的路由标识
  const routeId = `${targetPath}?${Object.entries(targetParams)
    .map(([key, value]) => `${key}=${value.partner}`)
    .join('&')}`;

  // 获取已访问路由记录
  const visitedRoutes = JSON.parse(sessionStorage.getItem(storageKey) || '{}');

  // 检查是否已访问
  if (visitedRoutes[routeId]) {
    return false;
  }

  // 标记为已访问并保存
  visitedRoutes[routeId] = Date.now();
  sessionStorage.setItem(storageKey, JSON.stringify(visitedRoutes));

  return true;
};

/**
 * 判断是否来自worldfirst渠道
 * @param {string} pathname 当前路径
 * @param {string} search 查询参数
 */
export const isWorldFirst = (pathname: string, search: string) => {
  // 检查路径是否匹配
  if (pathname !== TARGET_PATH) {
    return false;
  }

  // 解析URL参数
  const searchParams = new URLSearchParams(search);

  // 检查partner参数是否为worldfirst
  return searchParams.get('partner') === URL_PARAMS.partner && pathname === TARGET_PATH;
};
